/**
 * @param {string} s
 */
function parseDateTimeString(s) {
  if (s.indexOf("-") === -1 && s.indexOf(":") !== -1) {
    s = `1970-01-01 ${s}`;
  }

  if (s.indexOf("-") !== -1 && s.indexOf(":") === -1) {
    s = `${s} 00:00:00`;
  }

  return new Date(s);
}

/**
 * @param {Date | string | null} s
 *
 * @returns {Date | null}
 */
export function parseDateTime(s) {
  if (s == null) {
    return null;
  }

  if (s instanceof Date) {
    return isNaN(s) ? null : s;
  }

  const date = parseDateTimeString(s);

  return isNaN(date) ? null : date;
}

/**
 * @param {string | null}
 *
 * @returns {Date}
 */
export function parseUtcDateTime(s) {
  if (s == null) {
    return null;
  }

  if (s instanceof Date) {
    return isNaN(s) ? null : s;
  }

  return new Date(s + "Z");
}

/**
 * @param {Date | null} d
 *
 * @returns {string | null}
 */
export function toString(d) {
  if (d == null) {
    return null;
  }

  return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, -1)
    .replace("T", " ");
}

/**
 * @param {Date} d
 *
 * @returns {Date}
 */
export function startOfDay(d) {
  const r = new Date(d.getTime());
  r.setHours(0, 0, 0, 0);

  return r;
}

/**
 * @param {Date} d
 *
 * @returns {Date}
 */
export function startOfMonth(d) {
  const r = new Date(d.getTime());
  r.setDate(1);
  r.setHours(0, 0, 0, 0);

  return r;
}

/**
 * @param {Date} d
 *
 * @returns {Date}
 */
export function endOfDay(d) {
  const r = new Date(d.getTime());
  r.setHours(23, 59, 59, 999);

  return r;
}

/**
 * @param {Date} d
 *
 * @returns {Date}
 */
export function startOfWeek(d) {
  const r = new Date(d.getTime());
  r.setHours(0, 0, 0, 0);

  const day = r.getDay();
  const subs = day === 0 ? 6 : day - 1;
  r.setDate(r.getDate() - subs);

  return r;
}

/**
 * @param {Date | null} date
 *
 * @returns {string | null}
 */
export function toDateString(date) {
  if (date == null) {
    return null;
  }

  return new Intl.DateTimeFormat("fr-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}

/**
 * @param {Date} d1
 * @param {Date} d2
 *
 * @returns {Date}
 */
export function minDate(d1, d2) {
  return d1 <= d2 ? d1 : d2;
}

/**
 * @param {Date} d1
 * @param {Date} d2
 *
 * @returns {Date}
 */
export function maxDate(d1, d2) {
  return d1 < d2 ? d2 : d1;
}

/**
 * @param {Date} d1
 * @param {Date} d2
 *
 * @returns {number}
 */
export function yearsDiff(d1, d2) {
  if (d1 == null || d2 == null) {
    return null;
  }

  const yearDiff = d2.getFullYear() - d1.getFullYear();
  const monthDiff = d2.getMonth() - d1.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && d2.getDate() < d1.getDate())) {
    return yearDiff - 1;
  }

  return yearDiff;
}
